
import store from '../config/store'

export default {
  props: {
    baseUrl: {
      type: String,
      default: null
    }
  },

  data: () => ({
    store
  }),

  computed: {
    pagination () {
      return store.data.pagination
    },

    currentPageHigherThanFour () {
      return this.pagination.currentPage > 4
    },

    currentPageLowerThanMax () {
      return this.pagination.currentPage < this.pagination.pageCount - 4
    },

    dotsPagination () {
      let pagination = []
      for (let i = 1; i <= this.pagination.pageCount; i++) {
        pagination.push(i)
      }

      return pagination.slice(Math.max(0, this.pagination.currentPage - 4), Math.min(this.pagination.pageCount, this.pagination.currentPage + 3))
    },

    showDots () {
      return this.pagination.pageCount > 10
    }
  },

  mounted () {
    this.$bus.$on('reset-filter', this.onResetFilter)
    this.$bus.$on('reset-pagination', this.onResetFilter)
  },

  destroyed () {
    this.$bus.$off('reset-filter', this.onResetFilter)
    this.$bus.$off('reset-pagination', this.onResetFilter)
  },

  methods: {
    switchPage (page) {
      store.data.pagination.currentPage = page
    },

    onResetFilter () {
      if (this.pagination.currentPage > 1) {
        this.$router.push(this.baseUrl + '/page/' + this.pagination.currentPage)
      } else {
        this.$router.push(this.baseUrl)
      }
    }
  },
}

